import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-message-toast',
  templateUrl: './success-message-toast.component.html',
  styleUrls: ['./success-message-toast.component.css']
})
export class SuccessMessageToastComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
